import { StringUtils } from "../../Global/Base/Utils/StringUtils";

export class LocalizationUtils {
    private static readonly ATTRIBUTES_TO_SET_SEPARATOR = ",";

    public static parseLocalizationParams(paramsString: string): string[] {
        return JSON.parse(paramsString);
    }

    public static encodeLocalizationParams(params: string[]): string {
        return JSON.stringify(params);
    }

    public static parseAttributesToSet(attributes: string): string[] {
        return (attributes || "").split(LocalizationUtils.ATTRIBUTES_TO_SET_SEPARATOR);
    }

    public static encodeAttributesToSet(attributes: string | readonly string[]): string {
        return Array.isArray(attributes) ? attributes.join(LocalizationUtils.ATTRIBUTES_TO_SET_SEPARATOR) : attributes as string;
    }

    public static applyLocParams(text: string, params?: string[]): string {
        if (params && params.length)
            text = StringUtils.format(text, params)!;
        return (text == null || text == "null") ? "" : text;
    }
}
